// extracted by mini-css-extract-plugin
export default {"cls1":"buttonStyles-cls1__UD","cls2":"buttonStyles-cls2_kH9 buttonStyles-cls1__UD"};